import React from "react";

import { Slot, type Slottable } from "~/components/slot";
import { cx } from "~/tools/class-variance";

import { useDragHandleProps } from "./context/draggable";
import styles from "./_drag-and-drop.module.css";
import { enable } from "./_enabler";

export interface DragHandleProps extends Slottable, React.HTMLAttributes<HTMLElement> {
	children: React.ReactElement;
}

export const DragHandle = React.forwardRef<React.ComponentRef<"div">, DragHandleProps>(
	({ asChild = false, className, onMouseEnter, ...props }, ref) => {
		const Root = asChild ? Slot : "div";
		const handleProps = useDragHandleProps();

		return (
			<Root
				ref={ref}
				{...handleProps}
				{...props}
				className={cx(styles.dragHandle, className)}
				onMouseEnter={(event) => {
					enable();
					onMouseEnter?.(event);
				}}
			/>
		);
	},
);
